// GENERATED FILE - DO NOT MODIFY

export enum UserStatusDto {
    Active = "Active",
    Deactivated = "Deactivated",
}